import React from "react";

const ReportsIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.125 12.125L0.875 4.625H12.125L10.875 12.125H2.125ZM3.17188 10.875H9.82812L10.625 5.875H2.375L3.17188 10.875ZM5.25 8.375H7.75C7.92708 8.375 8.07552 8.3151 8.19531 8.19531C8.3151 8.07552 8.375 7.92708 8.375 7.75C8.375 7.57292 8.3151 7.42448 8.19531 7.30469C8.07552 7.1849 7.92708 7.125 7.75 7.125H5.25C5.07292 7.125 4.92448 7.1849 4.80469 7.30469C4.6849 7.42448 4.625 7.57292 4.625 7.75C4.625 7.92708 4.6849 8.07552 4.80469 8.19531C4.92448 8.3151 5.07292 8.375 5.25 8.375ZM2.75 4C2.57292 4 2.42448 3.9401 2.30469 3.82031C2.1849 3.70052 2.125 3.55208 2.125 3.375C2.125 3.19792 2.1849 3.04948 2.30469 2.92969C2.42448 2.8099 2.57292 2.75 2.75 2.75H10.25C10.4271 2.75 10.5755 2.8099 10.6953 2.92969C10.8151 3.04948 10.875 3.19792 10.875 3.375C10.875 3.55208 10.8151 3.70052 10.6953 3.82031C10.5755 3.9401 10.4271 4 10.25 4H2.75ZM4 2.125C3.82292 2.125 3.67448 2.0651 3.55469 1.94531C3.4349 1.82552 3.375 1.67708 3.375 1.5C3.375 1.32292 3.4349 1.17448 3.55469 1.05469C3.67448 0.934896 3.82292 0.875 4 0.875H9C9.17708 0.875 9.32552 0.934896 9.44531 1.05469C9.5651 1.17448 9.625 1.32292 9.625 1.5C9.625 1.67708 9.5651 1.82552 9.44531 1.94531C9.32552 2.0651 9.17708 2.125 9 2.125H4Z"
        fill="#03579E"
      />
    </svg>
  );
};

export default ReportsIcon;
